<template>
<div> 
    <Breadcrumbs main="EOD" title="EOD Sheet" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">
                                <div style="display: flex; flex-direction: row; align-items: center; gap: 12px; margin-top: -8px;">
                                        <div style="display: flex; flex-direction: column; align-items: start; width: 100%;">
                                            <h6 class="mt-2 mt-lg-1">Start Date:</h6>
                                            <datepicker placeholder="Start Date" :typeable="true" input-class="datepicker-here form-control digits" style="width: 100%;" v-model="startDate"></datepicker>
                                        </div> 
                                        <div style="display: flex; flex-direction: column; align-items: start; width: 100%;">
                                            <h6 class="mt-2 mt-lg-1">End Date:</h6>
                                            <datepicker placeholder="End Date" :typeable="true" input-class="datepicker-here form-control digits" style="width: 100%;" v-model="endDate"></datepicker>
                                        </div> 
                                    </div>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="datatable-select pt-xl-4">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <!-- <div class="row mt-2">
                            <div class="col-md-12">
                                <div class="col-sm-8 col-xl-6">
                                    <div style="display: flex; flex-direction: row; align-items: center; gap: 12px; margin-left: -16px;">
                                        <div style="display: flex; flex-direction: column; align-items: start; width: 100%;">
                                            <h6 class="mt-2 mt-lg-1">Start Date:</h6>
                                            <datepicker placeholder="Start Date" :typeable="true" input-class="datepicker-here form-control digits" style="width: 100%;" v-model="startDate"></datepicker>
                                        </div> 
                                        <div style="display: flex; flex-direction: column; align-items: start; width: 100%;">
                                            <h6 class="mt-2 mt-lg-1">End Date:</h6>
                                            <datepicker placeholder="End Date" :typeable="true" input-class="datepicker-here form-control digits" style="width: 100%;" v-model="endDate"></datepicker>
                                        </div> 
                                    </div>
                                </div>
                            </div>
                        </div> -->

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue" style="margin-top: 22px;">
                                <b-table show-empty stacked="md" :items="tableRows" :fields="tablefields" :per-page="perPage">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(employee)="data">
                                        <div style="min-width: 200px;">
                                            <router-link :to="`/hr/time-sheet/${data.item.employee.id}`" class="link-style">
                                                <strong>{{ data.item.employee.name }}</strong>
                                            </router-link><br />
                                            <small class="text-muted">{{ data.item.employee.email }}</small>
                                        </div>
                                    </template>

                                    <template #cell(submission)="data">
                                        <span class="text-primary fw-bold">{{ data.item.submission }} / {{ selectedDays }}</span>
                                    </template>

                                    <template v-for="date in allDates" v-slot:[`cell(${date})`]="data">
                                        <div style="min-width: 90px;">
                                            <span :class="getCellClass(data.item[date])">
                                                {{ data.item[date] ? '✔' : '✘' }}
                                            </span>
                                        </div>
                                    </template>

                                    <template #cell(status)="row">
                                        <span v-if="row.value == 'IN'">
                                            <b-badge pill variant="success">{{ row.value }}</b-badge>
                                        </span>
                                        <span v-if="row.value == 'OUT'">
                                            <b-badge pill variant="warning">{{ row.value }}</b-badge>
                                        </span>
                                        <span v-if="row.value == 'absent'">
                                            <b-badge pill variant="danger" class="text-uppercase">{{ row.value }}</b-badge>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>
                        <div v-else>
                            <div class="loader-box">
                                <div class="loader-10"></div>
                            </div>
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import Datepicker from 'vuejs-datepicker';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import moment from "moment";

export default {
    components: {
        Datepicker
    },

    data() {
        return {
            filterShow: false,
            statusSelected: '',
            monthSelected: new Date().getMonth(),
            monthName: '',
            startDate: '',
            endDate: '',
            selectedDepartment: '',
            selectedDesignation: '',
            selectedEmployee: '',
            totalRows: 1,
            currentPage: 1,
            perPage: 5,
            pageOptions: [5, 10, 25, 50, 100],
            statuses: [{
                    id: 1,
                    name: 'In',
                    value: 'IN'
                },
                {
                    id: 2,
                    name: 'Out',
                    value: 'OUT'
                }
            ],
            initialLoad: true,
        };
    },

    computed: {
        ...mapState({
            eod_sheet: state => state.eod.eod_sheet,
            count: state => state.eod.sheet_count,
            loading: state => state.eod.submitLoading,
            error: state => state.eod.submitError
        }),

        selectedDays() {
            const dateSet = new Set();

            this.eod_sheet.forEach(user => {
                user.eod.forEach(a => {
                    const [year, month, day] = a.date.split('-');
                    const key = `${year}-${month}-${day}`; // full date to count
                    dateSet.add(key);
                });
            });

            return dateSet.size; // number of unique days in that month
        },

        allDates() {
            const dateSet = new Set();
            this.eod_sheet.forEach(user =>
                user.eod.forEach(a => dateSet.add(a.date))
            );
            return [...dateSet].sort();
        },

        tableFields() {
            return [{
                    key: 'sl',
                    label: '#'
                },
                {
                    key: 'employee',
                    label: 'Employee'
                },
                {
                    key: 'submission',
                    label: 'Submission'
                },
                ...this.allDates.map(date => ({
                    key: date,
                    label: this.formatDayOnly(date)
                }))
            ];
        },

        tableRows() {
            return this.eod_sheet.map((user, index) => {
                const row = {
                    '#': (this.currentPage - 1) * this.perPage + index + 1,
                    employee: {
                        id: user.user_id.id,
                        name: user.user_id.full_name,
                        email: user.user_id.email
                    },
                    submission: user.eod.filter(a => a.submission).length
                };
                user.eod.forEach(entry => {
                    row[entry.date] = entry.submission;
                });
                return row;
            });
        }
    },

    mounted() {
        this.onMonthChange();

        if (this.initialLoad) {
            if (!this.$route.query.page || !this.$route.query.perPage) {
                this.$router.replace({
                    path: this.$route.path,
                    query: {
                        page: this.currentPage,
                        perPage: this.perPage
                    }
                }).catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        throw err;
                    }
                });
                this.fetchInitial();
            } else {
                this.currentPage = parseInt(this.$route.query.page);
                this.perPage = parseInt(this.$route.query.perPage);
                this.fetchInitial();
            }
        }
    },

    watch: {
        currentPage(newCurrentPage) {
            if (!this.initialLoad) {
                this.$router.replace({
                    path: '/eod/sheet',
                    query: {
                        page: newCurrentPage,
                        perPage: this.perPage
                    },
                });
                this.currentPage = newCurrentPage
                this.$store.dispatch("eod/fetchEODSheet", {
                    perPage: this.perPage,
                    currentPage: newCurrentPage,
                    start_date: this.startDate,
                    end_date: this.endDate
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false
                });
            }
        },

        perPage(newperPage) {
            if (!this.initialLoad) {
                this.$router.replace({
                    path: '/eod/sheet',
                    query: {
                        page: this.currentPage,
                        perPage: newperPage
                    },
                });
                this.perPage = newperPage
                this.$store.dispatch("eod/fetchEODSheet", {
                    perPage: newperPage,
                    currentPage: this.currentPage,
                    start_date: this.startDate,
                    end_date: this.endDate
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false
                });
            }
        },

        startDate(newVal, oldVal) {
            this.startDate = new Date(newVal).toISOString().split("T")[0];
            if (!this.initialLoad) {
                this.$store.dispatch("eod/fetchEODSheet", {
                    perPage: this.perPage,
                    currentPage: 1,
                    status: this.statusSelected,
                    start_date: this.startDate,
                    end_date: this.endDate
                }).then(() => {
                    this.items = this.eod_sheet
                    this.totalRows = this.count;
                    this.initialLoad = false
                });
            }
        },

        endDate(newVal, oldVal) {
            this.endDate = new Date(newVal).toISOString().split("T")[0];
            if (!this.initialLoad) {
                this.$store.dispatch("eod/fetchEODSheet", {
                    perPage: this.perPage,
                    currentPage: 1,
                    status: this.statusSelected,
                    start_date: this.startDate,
                    end_date: this.endDate
                }).then(() => {
                    this.items = this.eod_sheet
                    this.totalRows = this.count;
                    this.initialLoad = false
                });
            }
        }
    },

    methods: {
        formatDayOnly(dateStr) {
            return dateStr.split('-')[2];
        },

        getCellClass(submission) {
            return submission === true ?
                "text-success fw-bold" :
                submission === false ?
                "text-danger fw-bold" :
                "";
        },

        onMonthChange() {
            if (this.monthSelected === null || isNaN(this.monthSelected)) {
                this.startDate = '';
                this.endDate = '';
                this.monthName = '';
                return;
            }

            const year = new Date().getFullYear();
            const month = Number(this.monthSelected);

            const start = new Date(year, month, 1);
            const end = new Date(year, month + 1, 0);

            const format = (date) => {
                const yyyy = date.getFullYear();
                const mm = String(date.getMonth() + 1).padStart(2, '0');
                const dd = String(date.getDate()).padStart(2, '0');
                return `${yyyy}-${mm}-${dd}`;
            };

            this.startDate = format(start);
            this.endDate = format(end);
        },

        fetchInitial() {
            this.$store.dispatch("eod/fetchEODSheet", {
                perPage: this.perPage,
                currentPage: this.currentPage,
                start_date: this.startDate,
                end_date: this.endDate
            }).then(() => {
                this.totalRows = this.count;
                this.initialLoad = false;
            });
        }
    }
};
</script>
